import { createFragmentContainer, graphql } from 'react-relay';

import { ProvidersFragmentContainer } from '@feedback/main/src/Providers';

import createQueryRendererModern from '@feedback/main/src/relay/createQueryRendererModern';

import ExternalComplaint from './ExternalComplaint';

import { Root_query } from './__generated__/Root_query.graphql';

type Props = {
  query: Root_query;
};
const Root = ({ query }: Props) => {
  return (
    <ProvidersFragmentContainer query={query}>
      <ExternalComplaint query={query} />
    </ProvidersFragmentContainer>
  );
};

const RootFragmentContainer = createFragmentContainer(Root, {
  query: graphql`
    fragment Root_query on Query {
      ...Providers_query
      ...ExternalComplaint_query
    }
  `,
});

export default createQueryRendererModern(RootFragmentContainer, {
  query: graphql`
    query RootQuery {
      ...Root_query
    }
  `,
  loadingView: null,
});
